import * as types from "./actionTypes"

const initialState = {
    planShipmentData: {},
    plannedCarsCount: {},
    forcastingData: {
        inBound: {},
        onHand: {},
    },
}
export default function carsReducer(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_PLAN_SHIPMENT_DATA_SUCCESS:
            return {
                ...state,
                planShipmentData: action.payload,
            }
        case types.FETCH_TOTAL_PLANNED_CAR_DATA_SUCCESS:
            return {
                ...state,
                plannedCarsCount: action.payload,
            }
        case types.UPDATE_PLAN_COUNT_SUCCESS: {
            return {
                ...state,
            }
        }
        case types.SET_FROCASTING_CALCULATIONS: {
            return {
                ...state,
                forcastingData: action.payload,
            }
        }
        default:
            return state
    }
}
